'use strict';
angular.module('cvsApp').factory('paymentHistoryModel', ['commonModel',function(CM) {	
	
	var paymentHistoryModel = function(){
		
		var self = this;
		this.apiResponse = {};
		
		this.setResponse = function(data){
			CM.setResponse(data);			
		}	

		this.getResponse = function(data){
			self.apiResponse = CM.getResponse();	
			return self;		
		}	

		this.showView = function(){
			if(self.apiResponse.showView){	
				return false;
			}
			return true;
		}

		this.getError = function(){
			if(self.apiResponse.showError){	
				return self.apiResponse;
			}
			return "";
		}

		this.getPaymentHistory = function () {
			if(!self.apiResponse.showError){	
				return self.apiResponse;
			}
		}


	
	}
	
	return new paymentHistoryModel();
}]);